
namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class OrderInstallmentsDialog extends Serenity.EntityDialog<OrderInstallmentsRow, any> {
        protected getFormKey() { return OrderInstallmentsForm.formKey; }
        protected getIdProperty() { return OrderInstallmentsRow.idProperty; }
        protected getLocalTextPrefix() { return OrderInstallmentsRow.localTextPrefix; }
        protected getNameProperty() { return OrderInstallmentsRow.nameProperty; }
        protected getService() { return OrderInstallmentsService.baseUrl; }
        protected getDeletePermission() { return OrderInstallmentsRow.deletePermission; }
        protected getInsertPermission() { return OrderInstallmentsRow.insertPermission; }
        protected getUpdatePermission() { return OrderInstallmentsRow.updatePermission; }

        protected form = new OrderInstallmentsForm(this.idPrefix);

    }
}